module.exports = __webpack_public_path__ + "static/media/commercial.945b7e34.svg";